import * as Yup from "yup";

export const dataModel = {
  name: "",
  description: "",
  document: "",
  countries: [],
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      name: Yup.string().required("forms.validations.required"),
      description: Yup.string()
        .required("forms.validations.required")
        .max(1000, "forms.validations.max"),
      document: Yup.mixed().optional("forms.validations.required"),
      countries: Yup.array().optional("forms.validations.required"),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string().required("forms.validations.required"),
      description: Yup.string()
        .required("forms.validations.required")
        .max(1000, "forms.validations.max"),
      document: Yup.mixed().required("forms.validations.required"),
      countries: Yup.array().required("forms.validations.required"),
    });
  }
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
